/**
 * Created by shubham on 20/11/18.
 */

import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {BusinessUnitListPage} from "./businessUnitList-datatable/businessUnitList-page";
import {BusinessUnitListPageData} from "./businessUnitList-datatable/businessUnitList-page-data";
import {BusinessUnitListDashboard} from "./businessUnitList-datatable/businessUnitList-dashboard";

/**
 * A server used to mock a paged data result from a server
 */
@Injectable()
export class BusinessUnitListForUserDashboardResultService {
    listData:any;
    loginData;
    rows = {};
    adminDashboardData = {};

    constructor(){}

    /**
     * A method that mocks a paged server response
     * @param page The selected page
     * @returns {any} An observable containing the employee data
     */
    public getResults(page: BusinessUnitListPage,listData): Observable<BusinessUnitListPageData<BusinessUnitListDashboard>> {
        this.listData = listData;
        return Observable.of(listData).map(data => this.getPageData(page));
    }

    /**
     * Package companyData into a PagedData object based on the selected Page
     * @param page The page data used to get the selected data from companyData
     * @returns {PagedData<icsList>} An array of the selected data and page
     */
    private getPageData(page: BusinessUnitListPage): BusinessUnitListPageData<BusinessUnitListDashboard> {
        let pageData = new BusinessUnitListPageData<BusinessUnitListDashboard>();
        let offset = this.listData.offset;
        let raw = [];
        for(let l in this.listData){
            if(Object.keys(this.listData[l]).length > 0){
                raw[offset+parseInt(l)] = this.listData[l];
            }
        }
        if(this.listData.totalCount){
            page.totalElements = this.listData.totalCount;
        }
        page.totalPages = page.totalElements / page.size;
        let start = page.pageNumber * page.size;
        let end = Math.min((start + page.size), page.totalElements);
        for (let i = start; i < end; i++) {
            if(raw[i]){
                let jsonObj = raw[i];
                if(jsonObj){
                    let list = new BusinessUnitListDashboard(jsonObj['countryId'], jsonObj['countryName'], jsonObj['businessUnitId'],
                        jsonObj['businessUnitName'], jsonObj['emailVerified'], jsonObj['customerNumber'], jsonObj['selectedApplicationNames'],
                        jsonObj['status'], jsonObj['active']);
                    pageData.data.push(list);
                }
            }
        }
        pageData.page = page;
        return pageData;
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/user-operations/request-business-unit/businessUnitForUserDashboardResultService.ts